export const clearFilterData= {
  FuelTmSt: null,
  FuelTmEn: null,
  DrvId: null,
  TukId: null,
  GenId: null,
  IsChk: null,
}
export const initFilterData = {
  ...clearFilterData,
  IsChk: 0
}

export const initDialogData = {
  FuelTyp: "DSL",
  StnId: 1,
  FuelTm: null,
  TukId: null,
  DrvId: null,
  Litr: null,
  MileTukSt: null,
  MileTukEn: null,
  MileStnEn: null,
  MileStnSt: null,
  MileAdjPrct: 0,
  MileAdjKm: 0,
  Rmk: "",
  IsChk: 0,
}
